
import { Vue, Component, Prop, ModelSync } from "vue-property-decorator";
import Icon from "@/components/UI/Icon.vue";
import { ControlGroup } from "@/oxygen/classes/lib/types";

@Component({
  components: { Icon }
})
export default class OxygenGroup extends Vue {
  @Prop()
  control!: ControlGroup;

  @ModelSync("value", "input")
  syncedValue?: Record<string, unknown>;

  @Prop()
  path!: string;

  get fullPath() {
    return `${this.path}.${this.control.slug}`;
  }

  beforeCreate() {
    // @ts-ignore
    this.$options.components.OxygenControls =
      require("@/oxygen/classes/OxygenControls.vue").default;
  }

  get style() {
    if (this.control.columns) {
      return {
        "--controls-columns": this.control.columns
      };
    }

    return {};
  }
}
